/**
 * 리뷰 텍스트 포맷 유틸.
 * store/review 전용. 필요 시 store/utils로 승격 가능.
 */

export function truncateText(text: string, maxLength: number): string {
  if (text && text.length <= maxLength) return text;
  return text?.slice(0, maxLength) + "...";
}
